"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightRateEditor = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const legacy_1 = require("../../../Form/Field/Select/legacy");
const FlightRateEditor = (props) => {
    const { value, items, onValue, error, modifiers } = props.field;
    const fieldProps = {
        label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Edit:Rate', defaultMessage: 'Rate' })),
        modificators: modifiers,
        name: 'rate',
        error,
        value: value === null || value === void 0 ? void 0 : value.id,
        onSelect: (item) => {
            const selectedItem = item === '' ? undefined : items.filter(x => x.id === (item === null || item === void 0 ? void 0 : item.value)).pop();
            onValue(selectedItem);
        },
        items: ['', ...items.map((x) => ({ name: x.name, value: x.id }))],
    };
    return (react_1.default.createElement(legacy_1.LegacyFormFieldSelect, { ...fieldProps }));
};
exports.FlightRateEditor = FlightRateEditor;
//# sourceMappingURL=FlightRateEditor.js.map